import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function ManageFinanceMenu({ openItem = null, activeItem = null }) {
  return (
    <li
      className={`nav-item has-treeview 
          ${sidebarHelper.checkOpenItem(openItem, "manage-finance")} `}
    >
      <a
        href="# "
        className={`nav-link  
          ${sidebarHelper.checkActiveItem(openItem, "manage-finance")} `}
      >
        <i class="nav-icon fas fa-money-bill-wave-alt"></i>
        <p>
          مدیریت مالی
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/finance/manage/invoices"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(activeItem, "all-payments")} `}
          >
            <i class="fas fa-money-check-alt nav-icon"></i>
            <p>لیست پرداخت ها</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/all-transaction"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(activeItem, "all-transaction")} `}
          >
            <i class="fa fa-file-invoice-dollar nav-icon"></i>
            {/* <i class="fas fa-file-invoice nav-icon"></i> */}
            <p>لیست تراکنش ها</p>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to="/finance/manage/pledge"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "manage-all-pledge"
              )} `}
          >
            <i class="fa fa-file-invoice-dollar nav-icon"></i>
            <p>لیست بیعانه ها</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/all-gift"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(activeItem, "all-gift")} `}
          >
            <i class="fa fa-gifts nav-icon"></i>
            <p>لیست هدیه ها</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/marketer/ask-checkout"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "marketer-ask-checkout"
              )} `}
          >
            <i class="fa fa-money-bill-wave-alt"></i>
            <p>تسویه حساب بازاریابان</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/log-wallet"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "log-wallet-finance"
              )} `}
          >
            <i class="fa fa-file-invoice-dollar nav-icon"></i>
            <p style={{ fontSize: "12px" }}>لیست تغییرات موجودی حساب</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/gift-register-user/all"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "gift-register-user"
              )} `}
          >
            <i class="fa fa-gifts nav-icon"></i>
            <p>هدیه ثبت نام کاربران</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/gift-charge-user/all"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "gift-charge-user"
              )} `}
          >
            <i class="fa fa-gifts nav-icon"></i>
            <p>هدیه افزایش اعتبار کاربران</p>
          </Link>
        </li>
      </ul>
    </li>
  );
}
export default ManageFinanceMenu;
